import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { formatCentsToDollarString } from '../../utils/formatters/moneyDisplay';
import { get } from '../../../utils/shared/api';
import {
  LiFlexWrapper,
  ListItemFlexColumn,
  ListItemFlexColumnNum,
  InnerListWrapper,
  ListItemWrapper,
  ListItemFlexWrapper,
  ListContainer
} from './styled/base_components';

const InnerListRow = ({ leftCol, rightCol }) => (
  <LiFlexWrapper>
    <ListItemFlexColumn>{leftCol}</ListItemFlexColumn>
    <ListItemFlexColumnNum>{rightCol}</ListItemFlexColumnNum>
  </LiFlexWrapper>
);

InnerListRow.propTypes = {
  leftCol: PropTypes.string.isRequired,
  rightCol: PropTypes.string.isRequired
};

const InnerList = ({ rows }) => (
  <InnerListWrapper>
    {rows.map(row => <InnerListRow key={row.left} leftCol={row.left} rightCol={row.right} />)}
  </InnerListWrapper>
);

InnerList.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    left: PropTypes.string.isRequired,
    right: PropTypes.string.isRequired
  })).isRequired
};

const SummaryRow = ({ children }) => {
  const left = children[0];
  const right = children[1];
  const subContent = children[2];

  return (
    <ListItemWrapper>
      <ListItemFlexWrapper>
        {left && <ListItemFlexColumn>{left}</ListItemFlexColumn>}
        {right && <ListItemFlexColumnNum>{right}</ListItemFlexColumnNum>}
      </ListItemFlexWrapper>
      {subContent}
    </ListItemWrapper>
  );
};

SummaryRow.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired
};

const TransactionSummary = ({ appData }) => {
  const { brandProfileId } = JSON.parse(appData);
  const [data, setData] = useState();

  const getData = () => {
    get(`/api/v1/brand_profiles/${brandProfileId}/balance`, false).then(response => setData(response));
  };

  useEffect(() => {
    getData();
  }, []);

  if (!data) return null;

  const innerListValues = Object.keys(data.groups)
    .map(key => ({ left: key, right: formatCentsToDollarString(data.groups[key].balance_in_cents) }))

  return (
    <ListContainer>
      <SummaryRow>
        <h2>Balance</h2>
        <h2>{formatCentsToDollarString(data.overall.balance_in_cents)}</h2>
      </SummaryRow>

      <SummaryRow>
        <h5>Parent Category</h5>
        <h5>Balance</h5>
        <InnerList rows={innerListValues}/>
      </SummaryRow>
    </ListContainer>
  )
}

TransactionSummary.propTypes = {
  appData: PropTypes.string.isRequired
};

export default TransactionSummary;



// WEBPACK FOOTER //
// ./app/javascript/app/components/transactions/transaction_summary.jsx